import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';

export default function SelectorGender({ page = "" }) {
    const [textCombo, setTextCombo] = useState();
    const params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    //copy parameters URL to change 
    let paramsURL = { ...params }
    const data = [
        { code: 'TOT', label: Label({ data: 'LabelAllMedallists' }) },
        { code: 'M', label: Label({ data: 'HeaderMenDesc' }) },
        { code: 'W', label: Label({ data: 'HeaderWomenDesc' }) },
        { code: 'X', label: Label({ data: 'HeaderMixedDesc' }) },
        { code: 'O', label: Label({ data: 'HeaderOpenDesc' }) }
    ]

    useEffect(() => {
        let lbl = data.find(item => item.code === paramsURL["mirs_gender"])?.label
        if (!lbl) { lbl = <Label data={'LabelAllMedallists'} /> }
        setTextCombo(lbl);
    }, [paramsURL["mirs_gender"]]);


    const handleOnChange = (key) => {
        paramsURL["mirs_gender"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    return (

        <Dropdown onSelect={handleOnChange} id="selectorGender" className={"selectorContainer "} >
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                {textCombo}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item key={"Selector-Gender-1"} eventKey={"TOT"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"LabelAllMedallists"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Gender-2"} eventKey={"M"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"HeaderMenDesc"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Gender-3"} eventKey={"W"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"HeaderWomenDesc"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Gender-3"} eventKey={"X"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"HeaderMixedDesc"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Gender-3"} eventKey={"O"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"HeaderOpenDesc"} />
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};


